export default __webpack_public_path__ + "static/media/icon.2faf4e7d.png";